import Helpers from '../helpers/helpers';

export default class FilterBindings {
    constructor() {

        /* ClassNames */
        this._jsSelected = '_js-selected';
        this._jsFilterForm = '_js-filter-form';
        this._jsFilterFormWrap = '_js-filter-form-wrap';
        this._jsModalSelectWrap = '_js-modal-select-wrap';
        this._jsModalSelectList = '_js-modal-select-list';
        this.setDefaultFilters = '.js-setDefaultFilters';
        this.clearMobileFilter = '._js-mobile-filter-clear';

        this.countOfFilters = 0;

        this.$filter = $('.filter');
        this.$filterWrap = $('.form-search-wrap');
        this.filterPosition = this.$filter.offset();
        this.$outputValue = $('._js-filter__output');
        this.$filterItem = $('.filter__item');
        this.$fullFilter = $('._js-filter-full');
        this.marginUnderFilter = 20;

        /* Methods */
        if (this.$filter.length) {
            this.updateFilters();
            this.filterSwitcher();
            this.openModalSelect();
            this.closeModalSelect();
            this.updateCountOfFilters();
            this.fillPrice();
            this.calculateCheckbox();
            this.scrollPage();
            this.bindEvents();
        }

    }

    bindEvents() {
        this.$outputValue.on('click', (e) => {
            this.clearFilters(e);
        });
        $(document).on('click', this.clearMobileFilter, (e) => {
            this.clearFilters(e);
        });
        $(document).on('click', this.setDefaultFilters, () => {
            this.$outputValue.trigger('click');
        });
        //close filter modal for mobile
        $(document).on('click', '.js-filter-close, ._js-mobile-filter-count-btn', () => {
            let $body = $('body'),
                $html = $('html');

            $html.css({'position':'static'});
            $body.css({'overflow':'auto'});

            $html.scrollTop(parseInt($html.attr('data-scroll')));

            $('.filter').fadeOut(500, function () {});
        });
        $('._js-filter-cost').keypress(function (e) {
            if (e.which == 13) {

                setTimeout(() => {
                    if ($('#price').val().length > 0) {
                        $('#price').trigger('blur');
                    }
                }, 0);
            }
        });
    }

    updateFilters() {
        this.countOfFilters = 0;
        this.$filterItem.each((i, element) => {
            let $element = $(element);

            if ($element.find('input:checkbox').is(':checked')) {
                this.countOfFilters++;
            } else if ($element.find('select option:selected').not(':first-child').length) {
                this.countOfFilters++;
            } else if ($element.find('input[type=text]').val() || $element.find('input[type=text]').next().val()) {
                this.countOfFilters++;
            }
        });
        this.updateCountOfFilters();
        this.changeTopFilterPosition();
    }

    fillPrice() {
        $('._js-filter-cost').keypress(function (e) {
            let $that = $(this),
                fieldValue = $that.val();

            if (e.which != 8 && e.which != 0 && e.which != 46 && e.which != 44 && (e.which < 48 || e.which > 57)) {
                return false;
            } else if ((fieldValue.indexOf(',') > 0 || fieldValue.indexOf('.') > 0) && (e.which == 46 || e.which == 44)) {
                return false;
            }
        });

        $('._js-filter-cost').on('change', function () {
            let $that = $(this),
                fieldValue = $that.val();

            $that.val(fieldValue.replace('.', ','));
        });
    }

    filterSwitcher() {
        $('._js-filter-switcher').on('click', (e) => {
            let $target = $(e.target);
            e.preventDefault();

            $target.find('.filter__arrow-big').toggleClass('filter__arrow-big_open');
            this.$fullFilter.toggleClass('filter__wrap-more filter__wrap-more_hide');

            if (!this.$fullFilter.hasClass('filter__wrap-more_hide')) { //update nice-select plugin if full filter opened
                this.$fullFilter.find('select').niceSelect('update');
            }
        });
    }

    openModalSelect() {
        $('._js-modal-select').on('click', (e) => {
            let $target = $(e.target),
                $openedWindow = $target.next(),
                windowWidth = $(window).width(),
                $modalElement = $target.closest(`.${this._jsModalSelectWrap}`);


            if (!$modalElement.hasClass('field-list-wrap_open')) {
                this.hideSelects();
            }

            $modalElement.toggleClass('field-list-wrap_open');
            $openedWindow.fadeToggle(120);

            if ($openedWindow.offset().left + $openedWindow.width() > windowWidth) {
                $openedWindow.css('right', '0');
            }
            $openedWindow.css('visibility', 'visible');

        });
    }

    closeModalSelect() {
        $(document).on('click', (e) => {
            let $currentElement = $(e.target);

            if ($currentElement.closest(`.${this._jsModalSelectList}`).length || $currentElement.closest('._js-modal-select').length) return;
            this.hideSelects();
        });

        $(document).keyup((e) => {
            if (e.keyCode === 27) {
                this.hideSelects();
            }
        });

    }

    calculateCheckbox() {
        $(`.${this._jsModalSelectList} input[type=checkbox]`).on('click', (e) => {
            let $parentSelect = $(e.target).closest(`.${this._jsModalSelectWrap}`),
                numbOfManufacter = $parentSelect.find('input:checked').length;

            $parentSelect.children('._js-modal-select').text(numbOfManufacter === 0 ? 'Все' : ((numbOfManufacter += ' выбрано').length > 12 ? numbOfManufacter.slice(0, 9) + '...' : numbOfManufacter));
        });
    }

    hideSelects() {
        $(`.${this._jsModalSelectWrap}`).removeClass('field-list-wrap_open');
        $(`.${this._jsModalSelectList}`).fadeOut(100);
    }

    updateCountOfFilters() {

        if (this.countOfFilters && !Helpers.isMobile()) {
            this.$outputValue.val(this.countOfFilters + ' очистить');

            this.$outputValue.show();
            this.$outputValue.attr('data-is-seen', true);
        } else {
            this.$outputValue.hide();
            this.$outputValue.attr('data-is-seen', false);
            // this.clearFilters();
        }
    }

    clearFilters(e) {
        let $target = $(e.target),
            $form = $target.closest(`.${this._jsFilterForm}`);

        if (!$form.length) {
            $form = $(`.${this._jsFilterForm}`);
        }

        $form.find('input[type=text]').removeAttr('value').val('');
        $form.find('input[type=checkbox]').prop('checked', false);
        $form.find('select option').removeAttr('selected');
        $form.find('select option:first-child').prop('selected', true);
        $form.find('select').niceSelect('update');

        this.countOfFilters = 0;
        this.updateCountOfFilters();
        this.clearFilterSelectCustom();
        this.changeTopFilterPosition();

        setTimeout(() => {
            $('#price').trigger('clearFilter');
        }, 0);
    }

    clearFilterSelectCustom() {
        let $form = $(`.${this._jsFilterForm}`),
            $selectElement = $form.find('._js-modal-select');

        $selectElement.text('Все');
    }

    scrollPage() {
        $(document).scroll(() => {
            if (Helpers.isMobile()) {
                return;
            }

            if ($(window).scrollTop() > this.filterPosition.top - 16) {
                this.closeFullFilter();

                let filterHeight = this.$filter.height();
                $(`.${this._jsFilterFormWrap}`).height(filterHeight);

                this.changeTopFilterPosition();
                this.$filter.css('position', 'fixed');
            } else {
                $(`.${this._jsFilterFormWrap}`).height('auto');
                this.$filter.css('position', 'relative').css('top', 'auto');
            }
        });
    }

    changeTopFilterPosition() {
        var isClearFilterBtnSeen = this.$outputValue.attr('data-is-seen'),
            fixedFilterTopOffset = 0,
            filterElem = document.querySelector(`.${this._jsFilterFormWrap}`),
            topOffset = filterElem.getBoundingClientRect().top;

        if (isClearFilterBtnSeen === 'true' && topOffset < 16) {
            fixedFilterTopOffset = 15;
        }

        this.$filter.css('top', fixedFilterTopOffset);

        // this.$filter.css('position', 'fixed').css('top', topValue);
    }

    closeFullFilter() {
        let $switcherBtn = $('.filter__arrow-big');

        this.$fullFilter.addClass('filter__wrap-more_hide');
        this.$fullFilter.removeClass('filter__wrap-more');
        $switcherBtn.removeClass('filter__arrow-big_open');
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/form-search/FilterBindings.js